import clsx from 'clsx';
import useJoinGuideView from '../useJoinGuideView';
import JoinGuideModal_1 from './JoinGuideModal_1';
import { useState } from 'react';
import JoinGuideModal_2 from './JoinGuideModal_2';

interface IProps {
  onClick: () => void;
}

const JoinGuideView = ({ onClick }: IProps): JSX.Element => {
  const {
    checkboxStates,
    isRequiredTermsChecked,
    onChangeAllAgree,
    onChangeSingleCheck,
    onClickCheckBox,
    onClickNextBtn,
  } = useJoinGuideView(onClick);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);

  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="terms-title heading-4 font-bold">약관동의</h1>
        <div className="terms-list">
          <div className="terms-item">
            <label htmlFor="agree-all" className="terms-label text-lg font-medium">
              전체동의
              <input
                type="checkbox"
                id="agree-all"
                className="form-checkbox"
                checked={checkboxStates.allAgree}
                onChange={onChangeAllAgree}
                onClick={onClickCheckBox}
              />
            </label>
          </div>

          <div className="terms-divider"></div>

          <div className="terms-item">
            <label htmlFor="agree-service" className="terms-label text-base font-normal">
              <a
                href="#"
                className="terms-link terms-link-service text-base font-normal"
                onClick={(e) => {
                  e.preventDefault();
                  setIsModalOpen1(true);
                  onChangeSingleCheck('terms1');
                }}
              >
                전자지갑 서비스 이용약관 (필수)
              </a>
              <input
                type="checkbox"
                id="agree-service"
                className="form-checkbox required-checkbox"
                checked={checkboxStates.terms1}
                onChange={() => onChangeSingleCheck('terms1')}
              />
            </label>
          </div>

          <div className="terms-item">
            <label htmlFor="agree-privacy" className="terms-label text-base font-normal">
              <a
                href="#"
                className="terms-link terms-link-privacy text-base font-normal"
                onClick={(e) => {
                  e.preventDefault();
                  setIsModalOpen2(true);
                  onChangeSingleCheck('terms2');
                }}
              >
                개인정보 보호 및 동의 (필수)
              </a>
              <input
                type="checkbox"
                id="agree-privacy"
                className="form-checkbox required-checkbox"
                checked={checkboxStates.terms2}
                onChange={() => onChangeSingleCheck('terms2')}
              />
            </label>
          </div>
        </div>

        <button
          type="button"
          className={clsx('btn-primary signup-button text-lg font-semibold', { active: isRequiredTermsChecked })}
          // className="btn-primary signup-button text-lg font-semibold"
          id="termsNextBtn"
          onClick={onClickNextBtn}
        >
          다음
        </button>
      </div>

      {isModalOpen1 && <JoinGuideModal_1 onClose={() => setIsModalOpen1(false)} />}
      {isModalOpen2 && <JoinGuideModal_2 onClose={() => setIsModalOpen2(false)} />}
    </div>
  );
};

export default JoinGuideView;
